import { FC, Fragment } from 'react'

type Props = {
  examples: Example[]
  columns: Columns
}

type Example = {
  title: string
  color: string
  desc?: string
}

type Columns = {
  prices: string[]
  bands: string[]
  colors: string[][]
}

// tailwind css jit won't eval ${color} but it apply if compiled color is used other parts
const colorDiv = (color: string) => {
  const classes = `w-6 h-6 rounded-full bg-${color}`
  return <div className={classes} />
}

const Component: FC<Props> = ({ examples, columns: { prices, bands, colors } }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-col gap-4 md:gap-8 w-full">
        <h3 className="text-xl font-semibold text-secondary-700">活用例</h3>
        <div className="flex gap-4 flex-col md:flex-row">
          {examples.map((e) => {
            return (
              <Fragment key={e.title}>
                <div className="flex gap-2">
                  {colorDiv(e.color)}
                  <div>
                    <p className="leading-tight">{e.title}</p>
                    {e.desc ? <p className="mt-2 text-xs">{e.desc}</p> : <></>}
                  </div>
                </div>
              </Fragment>
            )
          })}
        </div>
        <div className="flex">
          <div className="flex flex-col items-center flex-1 gap-4">
            <p className="md:text-xl font-semibold text-secondary-700">容量</p>
            {bands.map((b) => (
              <p key={b} className="border-b border-1 border-divided w-full text-center pb-4">
                {b}
              </p>
            ))}
          </div>
          <div className="flex flex-col items-center flex-2 gap-4">
            <p className="text-base md:text-xl font-semibold text-secondary-700">料金</p>
            {prices.map((p) => (
              <p key={p} className="border-b border-1 border-divided w-full text-center pb-4">
                {p}
              </p>
            ))}
          </div>
          <div className="flex flex-col items-center flex-1 gap-4">
            <p className="text-base md:text-xl font-semibold text-secondary-700">活用シーン</p>
            {colors.map((c, idx) => {
              return (
                <div
                  key={idx}
                  className="flex gap-3 border-b border-1 border-divided w-full justify-center items-center pb-4"
                >
                  {c.map((_c, idx) => <Fragment key={_c + idx}>{colorDiv(_c)}</Fragment>)}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Component
